import React from "react";
import { Link } from "react-router-dom";
import { CABANAS } from "@/data/cabanas";
import { ArrowRight, Check } from "lucide-react";

export default function Cabanas() {
    return (
        <div className="bg-cdb-cream">
            <section className="pt-20 pb-12 sm:pt-28 sm:pb-16 leaf-pattern">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
                    <span className="text-cdb-gold text-sm font-bold uppercase tracking-widest">
                        Hospedagem
                    </span>
                    <h1
                        data-testid="cabanas-title"
                        className="text-4xl sm:text-5xl lg:text-6xl font-bold text-cdb-forest mt-3 mb-4 leading-tight"
                    >
                        Nossas cabanas
                    </h1>
                    <p className="text-cdb-earth/80 max-w-2xl mx-auto text-base sm:text-lg leading-relaxed">
                        Três experiências únicas para casais que valorizam simplicidade, conforto e a beleza da
                        Mata Atlântica.
                    </p>
                </div>
            </section>

            <section className="pb-24 sm:pb-32">
                <div className="max-w-7xl mx-auto px-6 lg:px-8 space-y-10">
                    {CABANAS.map((c, i) => (
                        <div
                            key={c.id}
                            data-testid={`cabana-row-${c.id}`}
                            className={`grid md:grid-cols-12 gap-6 lg:gap-10 items-center bg-white rounded-3xl p-4 sm:p-6 lg:p-8 border border-cdb-sand ${
                                i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""
                            }`}
                        >
                            <div className="md:col-span-7">
                                <div className="aspect-[16/10] rounded-2xl overflow-hidden">
                                    <img
                                        src={c.capa}
                                        alt={c.nome}
                                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                                    />
                                </div>
                            </div>
                            <div className="md:col-span-5">
                                <h2 className="text-2xl sm:text-3xl font-bold text-cdb-forest mb-2">{c.nome}</h2>
                                <p className="text-sm text-cdb-gold font-bold uppercase tracking-wider mb-4">
                                    {c.destaque}
                                </p>
                                <ul className="space-y-2 mb-6 max-h-48 overflow-hidden">
                                    {c.comodidades.slice(0, 5).map((item) => (
                                        <li key={item} className="flex items-start gap-2 text-sm text-cdb-earth">
                                            <Check className="w-4 h-4 text-cdb-forest mt-0.5 flex-shrink-0" />
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                                <div className="flex items-baseline gap-2 mb-6">
                                    <span className="text-3xl font-bold text-cdb-forest">
                                        R$ {c.diaria.toLocaleString("pt-BR")}
                                    </span>
                                    <span className="text-sm text-cdb-earth/60">/ noite</span>
                                </div>
                                <div className="flex flex-wrap gap-3">
                                    <Link
                                        to={`/cabanas/${c.slug}`}
                                        data-testid={`cabana-detalhes-btn-${c.id}`}
                                        className="inline-flex items-center gap-2 bg-cdb-forest hover:bg-cdb-forestDark text-white rounded-full px-6 py-3 font-bold transition-all"
                                    >
                                        Ver detalhes <ArrowRight className="w-4 h-4" />
                                    </Link>
                                    <Link
                                        to={`/reservas?cabana=${c.id}`}
                                        data-testid={`cabana-reservar-btn-${c.id}`}
                                        className="inline-flex items-center gap-2 bg-cdb-gold hover:bg-cdb-goldDark text-white rounded-full px-6 py-3 font-bold transition-all"
                                    >
                                        Reservar
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
}
